<template>
  <aside class="single_sidebar_widget search_widget">
    <div class="form-group" :class="{ 'mb-3': isFiltered }">
      <label class="input-group">
        <input
          v-model="searchValue"
          type="text"
          class="form-control"
          placeholder="Шукати за ключовим словом"
        />
        <button class="btns search-btn" type="button" @click="search">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192.904 192.904">
            <defs />
            <path
              d="M190.707 180.101l-47.078-47.077c11.702-14.072 18.752-32.142 18.752-51.831C162.381 36.423 125.959 0 81.191 0 36.422 0 0 36.423 0 81.193c0 44.767 36.422 81.187 81.191 81.187 19.688 0 37.759-7.049 51.831-18.751l47.079 47.078a7.474 7.474 0 005.303 2.197 7.498 7.498 0 005.303-12.803zM15 81.193C15 44.694 44.693 15 81.191 15c36.497 0 66.189 29.694 66.189 66.193 0 36.496-29.692 66.187-66.189 66.187C44.693 147.38 15 117.689 15 81.193z"
            />
          </svg>
        </button>
      </label>
    </div>
    <button
      v-if="isFiltered"
      class="button rounded-0 primary-bg text-white w-100 btn_1 boxed-btn"
      @click="clear"
    >
      Очистити пошук
    </button>
  </aside>
</template>

<script>
export default {
  name: "Search",
  props: {
    isFiltered: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  data: () => ({
    searchValue: ""
  }),

  methods: {
    search() {
      this.$emit("search", this.searchValue);
    },

    clear() {
      this.searchValue = "";
      this.$emit("clear");
    }
  }
};
</script>

<style>
.search-btn svg {
  width: 16px;
  height: 16px;
  fill: #fff;
}
</style>
